import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { UserService } from './user.service'
import { SystemUser2 } from '../models/system-user2';
import { UserGroup, UserGroupWithUserArrayToSendToServer } from '../models/usergroup';
import { UserGroupItem } from '../models/user-group-item';


@Injectable({
  providedIn: 'root'
})
export class UserGroupService {

  userGroups: UserGroupWithUserArrayToSendToServer[] = [];
  tempGroupsArray: UserGroupWithUserArrayToSendToServer[] = [];
  isSearchOn: boolean = false;

  constructor(private http: HttpClient, private userService: UserService) {

    this.getUserGroups();
    this.tempGroupsArray = this.userGroups;

  }

  search(searchInput: string){
    this.userGroups = this.tempGroupsArray;
    this.userGroups = this.userGroups.filter(x=> x.group_label.toLowerCase().includes(searchInput.toLowerCase()));
  }


  getUserGroups(): void {
    this.http.get<UserGroupWithUserArrayToSendToServer[]>('core-service/api/usergroups').subscribe(userGroupArray => {
      this.userGroups = userGroupArray;
      this.tempGroupsArray = userGroupArray
    });
  }

  xGetUserGroups(): Observable<UserGroup[]> {
    return this.http.get<UserGroup[]>('core-service/api/usergroups')
  }


  deleteUserGroup(groupId: number) {

    this.http.delete<any>('core-service/api/usergroups?group_id='+ groupId)
      .subscribe(success => {
        this.userGroups.splice(this.userGroups.findIndex(elem => elem.group_id === groupId).valueOf(), 1)
      });

  }

  createUserGroup(newUserGroupWithUsersArray: UserGroupWithUserArrayToSendToServer) {

    this.http.post('core-service/api/usergroups', newUserGroupWithUsersArray)
      .subscribe((res: UserGroup) => {
        this.getUserGroups();
      });
  }

  updateUserGroup(newUserGroupWithUsersArray: UserGroupWithUserArrayToSendToServer): Observable<any> {

    return this.http.put('core-service/api/usergroups', newUserGroupWithUsersArray)
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }



  /* reworking  how groups are edited */

  getUsersInGroup(groupId: number ) : Observable<any> {
    return this.http.get<UserGroupItem[]>("core-service/api/usergroups/get-users-in-group?groupId="+groupId);
  }

  updateGroupUser(userGroupItem: UserGroupItem) : Observable<boolean> {
    return this.http.put<boolean>("core-service/api/usergroups/update-group-user", userGroupItem)
  }

  getClassificationsInGroup(groupId: number ) : Observable<UserGroupItem[]> {
    return this.http.get<UserGroupItem[]>("core-service/api/usergroups/get-classifications-in-group?groupId="+ groupId);
  }

  getSitesInGroup(groupId: number ) : Observable<UserGroupItem[]> {
    return this.http.get<UserGroupItem[]>("core-service/api/usergroups/get-sites-in-group?groupId="+ groupId);
  }

  updateGroupSite(userGroupItem: UserGroupItem) : Observable<boolean> {
    return this.http.put<boolean>("core-service/api/usergroups/update-group-site", userGroupItem)
  }

  updateGroupClassification(userGroupItem: UserGroupItem) : Observable<boolean> {
    return this.http.put<boolean>("core-service/api/usergroups/update-group-classification", userGroupItem)
  }

  getPortsInGroup(groupId: number ) : Observable<UserGroupItem[]> {
    return this.http.get<UserGroupItem[]>("core-service/api/usergroups/get-ports-in-group?groupId="+ groupId);
  }

  updateGroupPort(userGroupItem: UserGroupItem) : Observable<boolean> {
    return this.http.put<boolean>("core-service/api/usergroups/update-group-port", userGroupItem)
  }

}
